class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.goalReached = false;
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    this.animateGoalProgress();
  }

  animateGoalProgress() {
    const progress = document.querySelector('#cart-goal-progress .cart-goal-progress');
    const fill = document.querySelector('#cart-goal-progress .cart-goal-progress__fill');
    if (!fill) return;

    const targetPercent = fill.dataset.percent || '0';
    requestAnimationFrame(() => {
      fill.style.width = `${targetPercent}%`;
    });

    const reached = progress.dataset.goalReached === 'true';
    if (reached && !this.goalReached) {
      setTimeout(launchConfetti, 500);
    }
    this.goalReached = reached;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-goal-progress',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

// Full-page one-shot confetti burst, no external library.
function launchConfetti() {
  const colors = ['#c9a86a', '#2f4a3c', '#e8d9c5', '#8a6d3b'];
  for (let i = 0; i < 80; i++) {
    const piece = document.createElement('span');
    piece.className = 'cart-goal-confetti';
    piece.style.left = `${Math.random() * window.innerWidth}px`;
    piece.style.top = '-2rem';
    piece.style.background = colors[i % colors.length];
    piece.style.setProperty('--x', `${(Math.random() - 0.5) * 240}px`);
    piece.style.setProperty('--fall', `${window.innerHeight + 40}px`);
    piece.style.setProperty('--rotate', `${Math.random() * 360}deg`);
    piece.style.animationDelay = `${Math.random() * 300}ms`;
    piece.style.animationDuration = `${1400 + Math.random() * 900}ms`;
    document.body.appendChild(piece);
    piece.addEventListener('animationend', () => piece.remove());
  }
}
